import {ContractInsurableObjectService} from "./service/api/contract-insurable-object.service";
import {ContractPersonService} from "./service/api/contract-person.service";
import {ContractPersonBenefitService} from "./service/api/contract-person-benefit.service";
import {ContractExternalFieldService} from "./service/api/contract-external-field.service";
import {ContractExternalBillingRecordService} from "./service/api/contract-external-billing-record.service";
import {ContractExternalBillingRecordItemService} from "./service/api/contract-external-billing-record-item.service";
import {InsurableObjectTypeService} from "./service/api/insurable-object-type.service";
import {InsurableObjectService} from "./service/api/insurable-object.service";
import {
    CiInsurableObjectObjectComponent
} from "./component/object-components/ci-insurable-object-object-component/ci-insurable-object-object.component";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {
    CiContractPersonComponent
} from "./component/protected-components/ci-contract-person-component/ci-contract-person.component";
import {
    CmCreateInsurableObjectPersonRelationPersonComponent
} from "../cm/component/protected-components/cm-create-insurable-object-person-relation-person/cm-create-insurable-object-person-relation-person.component";
import {
    CmCreateInsurableObjectOthersComponent
} from "../cm/component/protected-components/cm-create-insurable-object-others/cm-create-insurable-object-others.component";
// TM-1000001988 — the object component of ci.ContractSyncStatus, registered on that entry below.
import {
    CiContractSyncStatusObjectComponent
} from "./component/object-components/ci-contract-sync-status-object-component/ci-contract-sync-status-object.component";

export const CI_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ci.InsurableObjectField', {route: '/ci/insurableObjectFields'}],
            ['ci.ContractTypeInsurableObjectType', {route: '/ci/contractTypeInsurableObjectTypes'}],
            // Field requirements of the object-side host row above. Pure CRUD (no custom service
            // logic) — see ContractTypeInsurableObjectTypeReqFieldController, route verified against
            // its @RequestMapping. Consumed today only through
            // GET /mvsa/ci/contractTypeConfig (CiContractTypeConfigService), which resolves the
            // effective, inherited set; this registration is what lets a config screen edit the raw
            // rows the resolver reads from.
            ['ci.ContractTypeInsurableObjectTypeReqField', {route: '/ci/contractTypeInsurableObjectTypeReqFields'}],
            ['ci.InsurableObjectType', {route: '/ci/insurableObjectTypes', service: InsurableObjectTypeService}],
            ['ci.ContractPersonType', {route: '/ci/contractPersonTypes'}],
            ['ci.InsurableObjectTypeField', {route: '/ci/insurableObjectTypeFields'}],
            ['ci.ContractInsurableObject', {route: '/ci/contractInsurableObjects', service: ContractInsurableObjectService, objectComponent: [{mode: MvsCrudModeEnum.create, component: CmCreateInsurableObjectOthersComponent}]}],
            ['ci.ContractPerson', {
                route: '/ci/contractPersons',
                service: ContractPersonService,
                objectComponent: [
                    {mode: MvsCrudModeEnum.create, component: CmCreateInsurableObjectPersonRelationPersonComponent},
                    {mode: MvsCrudModeEnum.update, component: CiContractPersonComponent},
                ]
            }],
            // Update only, deliberately (design 15.5): the four customer-less call sites that create
            // an insurable object keep the generic form, so NO mode: create entry is registered here.
            // Registration through this native objectComponent registry rather than a service
            // override (gate condition GC8) - MvsCoreService.getObjectComponent:188-200 consults it
            // first and only then falls back to the service.
            //
            // mode = null RESOLVES TO THE GENERIC FORM - decided, not accidental. Every mapping below
            // carries an explicit mode, and resolveComponentMapping:41-64 only reaches its
            // unconditional-default branch, so a null mode matches nothing here and falls through to
            // InsurableObjectService.getObjectComponent, which returns null. The one host that passes
            // null is the routed ObjectPageComponent (object-page.component.ts:193) - and no route
            // opens ci.InsurableObject today, so the path is unreachable rather than merely unused.
            // An unconditional default mapping was rejected: it would ALSO capture mode=create and
            // break the signed decision that creating stays generic at the customer-less call sites.
            ['ci.InsurableObject', {
                route: '/ci/insurableObjects',
                service: InsurableObjectService,
                objectComponent: [
                    {mode: MvsCrudModeEnum.update, component: CiInsurableObjectObjectComponent}
                ]
            }],

            ['ci.CoverageType', {route: '/ci/coverageTypes'}],
            ['ci.CoverageComponent', {route: '/ci/coverageComponents'}],
            ['ci.ContractCoverage', {route: '/ci/contractCoverages'}],

            ['ci.ContractInsurableObjectCoverage', {route: '/ci/contractInsurableObjectCoverages'}],
            ['ci.ContractTypeContractPersonType', {route: '/ci/contractTypeContractPersonTypes'}],
            // Field requirements of the person-side host row above. Pure CRUD (no custom service
            // logic) — see ContractTypeContractPersonTypeReqFieldController, route verified against
            // its @RequestMapping. Same consumption story as the object-side sibling above: the
            // effective set is read through GET /mvsa/ci/contractTypeConfig
            // (CiContractTypeConfigService); this registration is for editing the raw rows.
            ['ci.ContractTypeContractPersonTypeReqField', {route: '/ci/contractTypeContractPersonTypeReqFields'}],

            ['ci.ContractPersonBenefit', {route: '/ci/contractPersonBenefits', service: ContractPersonBenefitService}],
            ['ci.ContractExternalField', {route: '/ci/contractExternalFields', service: ContractExternalFieldService}],
            ['ci.ContractExternalBillingRecord', {route: '/ci/contractExternalBillingRecords', service: ContractExternalBillingRecordService}],
            ['ci.ContractExternalBillingRecordItem', {route: '/ci/contractExternalBillingRecordItems', service: ContractExternalBillingRecordItemService}],

            // External side-car entities (ci.ContractExt*) - route-only, DELIBERATELY without a
            // service or DTO class. These are consumed READ-ONLY by QL table widgets.
            //
            // The alias reaches this registry through the DATA PROVIDER chain, not through the QL
            // query itself: core-dp.service.ts:54-56 stamps widgetData.dataProviderObject from
            // core-ds-impl-ql.service.ts:49-51 (getObjectName -> request.getStartEntity()), which is
            // ql-request.dto.ts:156-158 (`this.queries[0]?.start?.name`). So from the first
            // refreshComponent() onward dataProviderObject is e.g. 'ci.ContractExtSparte'. The
            // phase-1 discovery query itself runs through QlService -> POST /core/ql/query and never
            // consults this registry.
            //
            // That alias is then resolved via MvsCoreService.getCrudService, which at
            // mvs-core.service.ts:150-154 falls back to a generically constructed
            // `new MvsCrudService(http, baseUrl + route)` whenever no `service` is registered.
            // Consumers: row edit (mvs-widget-table.component.ts:1191, :1302), copy (:1419),
            // quick-add (:1321) and header-filter value lists (:1835).
            //
            // READ + NAVIGATION ONLY - deliberate scope. Registering these aliases ALSO makes
            // PUT/POST to /mvsa/ci/contractExt* reachable through that generic MvsCrudService IF the
            // context-menu params are ever enabled. Today they are not: prepareContextMenuButtons()
            // (mvs-widget-table.component.ts:784-820) gates edit on
            // `editOption == 'contextMenu' || formEdit` and copy on `formCopy`, none of which
            // createWidgetTableQl sets, so the context menu stays hidden. But those are
            // configParamRuntime params persisted per alias in ui.UiWidget / ui.UiWidgetLayout, so a
            // config admin flipping formEdit on one of these aliases would silently enable editing of
            // importer-owned mirror rows. Do not enable them for these entities.
            //
            // No runtime lookup anywhere maps an alias to a frontend DTO class - DTOs are
            // compile-time typings for hand-written services/components only, so adding them here
            // would be dead code. A typed service/DTO is only warranted once one of these entities
            // gains a form, a create dialog, or an object component.
            //
            // The ci.ContractExt*Field sibling entities are deliberately NOT registered: no widget
            // uses a *Field entity as its start entity, so no alias for them ever reaches this
            // registry - registering them would achieve nothing.
            //
            // Routes verified 1:1 against the backend @RequestMapping in
            // apps/backend/api/src/main/java/com/mvs/backend/ci/controller/ (all /mvsa/ci/{camelPlural}).
            ['ci.ContractData', {route: '/ci/contractDatas'}],
            ['ci.ContractExtData', {route: '/ci/contractExtDatas'}],
            // [TM-1000001988 overnight C] — the delivered contract header's generic FIELD VALUES, read
            // by arm 3's „Lieferung (GDV) — Vertragskopf" card through
            // buildDeliveredContractHeaderFieldsRequest.
            //
            // ⚠ IT HAD TO BE REGISTERED: the values live in cc.FieldValue, which QL exposes only as
            // id/dataType, so the resolved scalar is reachable ONLY through the generic CRUD list —
            // the same reason ci.ContractExtObjectField below is registered. Without this line
            // getCrudService() answers null and the card can render nothing but its failure sentence.
            //
            // Route verified against the backend @RequestMapping: ContractExtDataFieldController is
            // /mvsa/ci/contractExtDataFields.
            ['ci.ContractExtDataField', {route: '/ci/contractExtDataFields'}],
            // TM-1000001985 (D14): the SECOND writable exception in this block, for the same reason as
            // ci.ContractExtCustomer below. The delivered NAME/birth date on a ci.ContractExtPerson row
            // is importer-owned payload and stays untouched, but its BINDING STATE (status, reasonText)
            // is a processing result a human owns: „Ignorieren" / „Wieder öffnen" / „Begründung
            // bearbeiten" in the Personenzuordnung workbench resolve this alias via
            // MvsCoreService.getCrudService and PUT exactly those two attributes — no bespoke backend
            // endpoint exists behind them. Same rule as there: NEVER echo the GET payload back (its
            // generated form block answers 400 "Failed to read request"), and never write any delivered
            // field through this route. See ci-convert-person.component.ts, executeRowPatches().
            ['ci.ContractExtPerson', {route: '/ci/contractExtPersons'}],
            ['ci.ContractExtPersonRole', {route: '/ci/contractExtPersonRoles'}],
            ['ci.ContractExtSparte', {route: '/ci/contractExtSpartes'}],
            ['ci.ContractExtPersonSparte', {route: '/ci/contractExtPersonSpartes'}],
            ['ci.ContractExtObject', {route: '/ci/contractExtObjects'}],
            // TM-1000001988 — READ ONLY, and the only route in this list that exists for its VALUES.
            //
            // ⚠ It is registered because the generic CRUD list is the ONLY way to read a delivered
            // object's generic field values at all. `cc.FieldValue` carries just id + dataType; the
            // value lives in a per-type sibling table joined by shared primary key with no JPA relation,
            // which QL's meta layer classifies as an „any field value" and answers with the bare FK id.
            // `core/dto/DtoService` resolves it server-side onto the `fieldValue` DTO attribute — so
            // this route returns the chip number where a query returns a database id.
            //
            // ⚠ NOTHING MAY EVER WRITE THROUGH IT. These are delivered facts; correcting one would
            // falsify what the partner sent. The status-5 arm reads them so a caseworker can copy them
            // onto Alpha's own object by hand.
            ['ci.ContractExtObjectField', {route: '/ci/contractExtObjectFields'}],
            ['ci.ContractExtCoverage', {route: '/ci/contractExtCoverages'}],
            ['ci.ContractExtCoveragePerson', {route: '/ci/contractExtCoveragePersons'}],
            ['ci.ContractExtCoverageObject', {route: '/ci/contractExtCoverageObjects'}],
            // TM-1000001985: route-only like the rest of this block, but — unlike the rest — this
            // alias is deliberately WRITABLE through the generic CRUD path. The rows above mirror
            // importer-owned delivered payload and are read-only; a ci.ContractExtCustomer row is a
            // processing RESULT that a human edits, and the confirm action of the ci/convert
            // workbench ("Zuordnung bestätigen") IS that edit: the panel resolves this alias via
            // MvsCoreService.getCrudService and PUTs status = ASSIGNED, the confirmed customer, the
            // winning matchType and assignedAt. That generic PUT is the screen's write path — there
            // is no bespoke confirm endpoint behind it — so this route must stay registered and
            // reachable for writes.
            //
            // It PUTs those four attributes and NOTHING else. The row that GET returns must never be
            // echoed back: it carries the generated form block, which the same route answers with
            // 400 "Failed to read request". See the ci-convert customer detail panel's
            // updateBindingRow().
            ['ci.ContractExtCustomer', {route: '/ci/contractExtCustomers'}],
            // A QL table widget reads it and it serves header-filter value lists — AND, since
            // TM-1000001988 WP-11, it carries the status-branching object component below.
            //
            // ⚠ NO `mode` ON THE MAPPING, and that is the decision. resolveComponentMapping tries
            // mode+viewType, then viewType, then mode, and falls back to the unconditional DEFAULT
            // entry — which is what a bare {component} is. That default is what we want here: this row
            // is never CREATED from a screen (the SideCar writes it on import and the pipeline's jobs
            // move it), so there is no create surface to keep generic and every reachable mode wants
            // the same component. A mode: update entry would leave the routed object page — which
            // passes mode = null (object-page.component.ts) — falling through to the generic form.
            //
            // ⚠ The route is READ-CRITICAL. It is how the table widget and — through
            // ObjectBaseComponent.refreshObject, which resolves the crud service by object type itself
            // — the OBC above LOAD a row. Re-pointing or removing it leaves the workbench unable to
            // display anything.
            //
            // ⚠ It is NOT how the status is WRITTEN, and that is a deliberate change rather than an
            // omission: the three workbench transitions go through the dedicated
            // POST /mvsa/ci/contractSyncStatuses/{id}/advance action (see
            // CiContractSyncService.advanceStatus), which funnels through the server's single
            // transition owner. The generic CRUD PUT on this route applied NO validation to the
            // ordinal — it would have accepted COMPLETED from MAP_CUSTOMER_CASE_MANUAL, skipping the
            // whole pipeline including the quality check — so nothing here may route a status write
            // back through it.
            //
            // ⚠ THE WORKBENCH NO LONGER MOUNTS THE COMPONENT THROUGH THIS ENTRY. The detail pane is
            // keyed on the cm.Contract and RESOLVES this row itself (one QL read —
            // CiContractSyncService.findSyncStatusByContract), which is what makes the job-owned
            // statuses reachable at all and lets the pane be opened from anywhere a contract is known.
            // The registration stays because the component still ACCEPTS a row identifier and renders
            // correctly for one — see its class TSDoc — so opening a ci.ContractSyncStatus as an object
            // remains meaningful rather than falling through to the generic form.
            ['ci.ContractSyncStatus', {
                route: '/ci/contractSyncStatuses',
                objectComponent: [
                    {component: CiContractSyncStatusObjectComponent}
                ]
            }],
            // TM-1000001988 — the findings a pipeline step recorded on a contract, read by the
            // „Verarbeitungsstatus" detail (WP-11) in its CASE_ALIGNMENT_MANUAL arm: without this
            // registration the alias resolves to no service and the rows cannot be read at all.
            //
            // Route verified against the backend, not guessed: ContractSyncMessageController carries
            // @RequestMapping("/mvsa/ci/contractSyncMessages"), and registrations here omit the /mvsa
            // prefix exactly as the ci.ContractSyncStatus line above does.
            //
            // Route-only, and it stays route-only: a finding is read as a ROW in the list its pipeline
            // row's detail renders (CiContractSyncStatusObjectComponent's CASE_ALIGNMENT_MANUAL arm,
            // via CiContractSyncService.listSyncFindings — TM-1000001988; the QL projection this line
            // used to name, listSyncMessages, is deleted), never opened as an object of its own. An
            // objectComponent here would offer a detail view of a row that is deleted and rewritten by
            // the next run of the step.
            //
            // ⚠ These rows are deliberately NOT audited and are deleted-and-rewritten per run, scoped
            // by (contractSyncStatus) ALONE — every run replaces the contract's findings in full.
            // „Was this contract flagged last delivery?" is unanswerable by design, so nothing built on
            // this alias may present the list as a history.
            //
            // ⚠ AND A FINDING CARRIES NO STEP PROVENANCE. The delete is all-or-nothing per contract:
            // the entity has exactly one relation, the FK above, and one index on it
            // (ci_contract_sync_message_p1). There was briefly a `source` axis — the row, the enum
            // ci/enums/ContractSyncMessageSourceEnum and a second index — and all three were removed;
            // the index would only have duplicated _p1. So „which step raised this?" cannot be answered
            // from the data. A UI that wants to GROUP or LABEL findings by originating step has nothing
            // to read, and must not invent one — not from the row's order, not from the contract's
            // current status (which has moved on by the time a person reads the list).
            ['ci.ContractSyncMessage', {route: '/ci/contractSyncMessages'}],
            // NOTE — TM-1000001985: the `ci.PartnerExtConfig` registration stood HERE and is gone,
            // together with the backend entity behind it, the „Partner-Konfiguration" tab of the ci
            // config page and the CiPartnerMatchingModeEnum mirror.
            //
            // ⚠ Do not re-add it. That entity was a per-external-party CONFIGURATION row that merely
            // restated defaults the platform already expresses on its own type entities, so it gave
            // the same value two homes and no rule for which one wins. There is no route to register
            // any more — a registration here would resolve a generic MvsCrudService against
            // /mvsa/ci/partnerExtConfigs, which the backend no longer serves.
        ] as EntityServiceEntry[],
        multi: true
    }
];
